import { render, staticRenderFns } from "./mainbusinessPage9.vue?vue&type=template&id=01f35c91&scoped=true&"
import script from "./mainbusinessPage9.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage9.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage9.vue?vue&type=style&index=0&id=01f35c91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f35c91",
  null
  
)

export default component.exports